/**
 * @generated SignedSource<<b671d5270f7f8bb42e33c548f0cf51b7>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum ConfluenceSpaceRoleMode {
  PRE_ROLES = "PRE_ROLES",
  ROLES = "ROLES",
  ROLES_TRANSITION = "ROLES_TRANSITION",
}
export type useSpaceRoleModeQuery_Query = {
  __typename?: "Query";
  confluence_spaceRoleMode: ConfluenceSpaceRoleMode | null;
};
export type useSpaceRoleModeQueryVariables = Exact<{
  cloudId: Scalars["ID"]["input"];
}>;
export type useSpaceRoleModeQuery = useSpaceRoleModeQuery_Query;
